import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryPerformanceCard = ({ name, itemCount, views, rating, trend }) => {
  const getTrendIcon = () => {
    if (trend === 'up') return { name: 'TrendingUp', color: 'var(--color-success)' };
    if (trend === 'down') return { name: 'TrendingDown', color: 'var(--color-error)' };
    return { name: 'Minus', color: 'var(--color-muted-foreground)' };
  };

  const trendIcon = getTrendIcon();

  return (
    <div className="bg-card rounded-lg p-4 md:p-5 glow-secondary transition-smooth hover:glow-secondary-hover">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <h5 className="text-sm md:text-base font-heading font-bold text-foreground line-clamp-2 flex-1">
          {name}
        </h5>
        <Icon name={trendIcon?.name} size={20} color={trendIcon?.color} />
      </div>
      <div className="grid grid-cols-3 gap-2 md:gap-3">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Itens</p>
          <p className="text-base md:text-lg font-bold text-foreground">{itemCount}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Views</p>
          <p className="text-base md:text-lg font-bold text-foreground">{views}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Rating</p>
          <div className="flex items-center gap-1">
            <Icon name="Star" size={14} color="var(--color-warning)" />
            <p className="text-base md:text-lg font-bold text-foreground">{rating}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPerformanceCard;